import { useMemo } from 'react';
import DynamicFormBuilder from '../components/admin/DynamicFormBuilder';
import { getAdminApplyForm, saveAdminApplyForm } from '../services/adminService';

function AdminApplyCms() {
  const defaultForm = useMemo(
    () => ({ title: 'FactorStreet Job Application Form', status: 'draft', categories: [] }),
    []
  );

  return (
    <DynamicFormBuilder
      defaultForm={defaultForm}
      eyebrow="Apply CMS"
      heading="Application form"
      loadForm={getAdminApplyForm}
      saveForm={saveAdminApplyForm}
      saveSuccessMessage="Application form saved."
    />
  );
}

export default AdminApplyCms;
